import { useQuotationsStore } from '../store/quotations'

/**
 * Nouveau devis (#/new/...) : réinitialiser currentQuotation depuis emptyQuotation
 * lorsqu’on arrive depuis l’extérieur du flux /new/* (accueil, liste devis, etc.).
 * Navigation entre /new/products, /new/contact, /new/infos : on conserve le brouillon en mémoire.
 * Changement de ?type= dans le même flux /new/* : réinit avec le nouveau métier.
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.params.quoteid !== 'new') return

  const fromPath = from?.path || ''
  const cameFromNewSection = fromPath.startsWith('/new/')

  const quotationsStore = useQuotationsStore()

  if (cameFromNewSection) {
    const toType = to.query.type
    const fromType = from.query.type
    if (toType && fromType && String(toType) !== String(fromType)) {
      await quotationsStore.initializeCurrentQuotation(String(toType))
    }
    return
  }

  // Ne pas reprendre l’ancien brouillon : le type vient de l’URL ou défaut mobilier.
  const type = (to.query.type as string) || 'mobilier'

  await quotationsStore.initializeCurrentQuotation(type)
})
